import script from "./QuestionBanner.vue?vue&type=script&lang=ts&setup=true"
export * from "./QuestionBanner.vue?vue&type=script&lang=ts&setup=true"

import "./QuestionBanner.vue?vue&type=style&index=0&id=a8b43dce&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a8b43dce"]])

export default __exports__